import { BaseVideoPlayer, PageDropZone } from '@tempots/beatui'
import { attr, Fragment, html, on } from '@tempots/dom'
import { RESUME_UPLOAD_ACCEPT } from '@rh/shared/constants/resume-content-types'
import { Notify } from '@rh/shared/utils/notify'
import { Track } from '@/services/track'

export interface HomeDropZoneOptions {
  setResumeFile: (file: File) => void
}

export function HomeDropZone({ setResumeFile }: HomeDropZoneOptions) {
  return html.div(
    PageDropZone({
      accept: RESUME_UPLOAD_ACCEPT,
      onInvalidSelection: () => {
        Notify.warn('Invalid resume file')
        Track.uploaded({
          status: 'fail',
          error_code: 'INVALID_FILE_TYPE',
        })
      },
      onChange: ((files: File[], via: 'dragdrop' | 'click' | undefined) => {
        if (files.length === 0) return
        const file = files[0]
        Track.upload({ trigger: via, section: 'home_drop_zone' })
        setResumeFile(file)
      }) as (files: File[]) => void, // TODO remove once beatui is up to date
      content: ({ selectFiles }) =>
        Fragment(
          on.click(selectFiles),
          attr.class(
            'flex flex-col gap-3 sm:gap-4 items-center border-2 border-dashed border-teal-700 p-3 sm:p-4 md:p-6 rounded-2xl bg-white w-full max-w-full sm:max-w-lg md:max-w-xl lg:max-w-2xl cursor-pointer'
          ),
          html.div(
            attr.class(
              'text-center text-lg sm:text-xl md:text-2xl font-semibold text-teal-700'
            ),
            html.span(
              attr.class('hidden sm:inline'),
              'Drop a resume here to try it now',
              html.sup('*')
            ),
            html.span(attr.class('sm:hidden'), 'Drop or tap to upload')
          ),
          html.div(
            attr.class(
              'text-center text-xs sm:text-sm font-semibold text-teal-700 mb-2 sm:mb-4'
            ),
            html.span(attr.class('font-mono'), '.pdf'),
            ', ',
            html.span(attr.class('font-mono'), '.docx'),
            ', ',
            html.span(attr.class('font-mono'), '.doc'),
            ',  images, and more...'
          ),
          html.div(
            attr.class(
              'text-center text-sm text-gray-600 w-full select-none max-w-full sm:max-w-96 md:max-w-124 rounded-xl overflow-clip'
            ),
            BaseVideoPlayer({
              url: '/video/resumeheaders-splash-demo.mp4',
              playing: true,
              loop: false,
              muted: true,
              width: '100%',
              height: 'auto',
            })
          ),
          html.div(
            attr.class(
              'text-xs sm:text-sm font-semibold text-gray-600 mt-2 sm:mt-4'
            ),
            'We never save or share resumes!'
          )
        ),
    })
  )
}
